<template>
    <li class="menu-item" :class="{ 'menu-item-active': isActive(routeName) }"
        :data-container="hasPermission && locked ?'body' : false"
        :data-toggle="hasPermission && locked ? 'popover' : false"
        :data-placement="hasPermission && locked ? 'right' : false"
        :data-content="hasPermission && locked ? lockedText : false"
    >
        <a :href="url" class="menu-link" :target="targetBlank ?  '_blank' : '' ">
            <span class="menu-icon d-flex justify-content-center mr-1">
               <i :class="icon"></i>
            </span>
            <span class="menu-text">{{ label }}</span>
            <span v-if="hasPermission && !locked" v-show="badge && badge > 0" :id="badgeId ?? generatedId" class="menu-label pulse pulse-primary">
                <span class="label label-rounded label-primary">{{ badge }}</span>
                <span class="pulse-ring d-none" style="margin-left: -10px;"></span>
            </span>
            <i v-else-if="hasPermission && locked" class="pl-4 menu-icon text-center fas fa-lock"></i>
        </a>
    </li>
</template>

<script>

import helperMethods from '@mixins/helperMethods'

export default {
    mixins: [helperMethods],
    props: {
        label: String,
        icon: String,
        url: String,
        routeName: String,
        targetBlank: Boolean,
        permission: {
            type: Boolean,
            default() {
                return null
            },
        },
        badge: String,
        badgeId: {
            type: String,
            default() {
                return null
            },
        },
        lockedText: String,
    },
    methods: {
        isActive(routeName) {
            return this.$route().current() === routeName;
        },
    },
    computed: {
        hasPermission() {
            return this.permission !== null
        },
        locked() {
            return !this.hasPermission
        },
    },
}
</script>
